import React from 'react'
import Button from '../Button'
import Copyright from '../Copyright'
import FactsData from './../../factsData.json'
import Image from '../Image'
import ScrollBar from 'react-scrollbar'
import SocialSharing from '../SocialSharing'
import Tag from '../Tag'
import classNames from 'classnames'

import './style.scss'

class ModalDefault extends React.Component {
  constructor(props) {
    super(props)

    this.data = this.getFactData()
    this.nextFact = this.nextFact.bind(this)

    this.state = {
      addNewModalContent: false,
      canClickNextFact: true
    }
  }

  componentDidMount() {
    this.modal = document.querySelector('.modal')
    this.elementReload = this.modal.querySelector('.reload')
    this.elementReload.addEventListener('click', this.nextFact)
    this.getLineBreakText(this.modal.querySelector('.introductory-text'))
    this.getLineBreakText(this.modal.querySelector('.description'))
  }

  getLineBreakText(element) {
    const introductoryTextWidth= element.offsetWidth
    const temporarySpan = document.createElement('span')
    let text = element.innerHTML.split(' ')
    let arrSpans = ''
    let line = 0
    let newText = ''
    let span = ''
    let width = 0
    for (let i = 0; i < text.length; i++) {
      temporarySpan.innerHTML = (width === 0) ? text[i] : '&nbsp;' + text[i]
      element.parentNode.insertBefore(temporarySpan, element)
      width += temporarySpan.offsetWidth

      if (width < introductoryTextWidth - 25) {
        span += temporarySpan.innerHTML
        if (width === 0) {
          newText += text[i]
        } else {
          newText += text[i] + ' '
        }
      } else {

        // Проверка конфига. Не больше строк, чем указано в параметре data-lines
        if (line >= element.dataset.lines - 1) {
          span = span.trim().replace(/([,!]|(&nbsp;—))$/, '')

          let ellipsis = ''
          if (span.slice(-1) !== '.') {
            ellipsis = '<span className="ellipsis">...</span>'
          }

          arrSpans += '<span>' + span + ellipsis + '</span>'

          text = newText.split(' ')
          break
        } else {
          arrSpans += '<span>' + span + '</span>'
        }

        i--
        line++
        span = ''
        width = 0
      }
    }

    if (!element.dataset.lines) {
      arrSpans += '<span>' + span + '</span>'
    }

    element.innerHTML = arrSpans
    temporarySpan.parentNode.removeChild(temporarySpan)

    window.addEventListener('resize', () => {
      this.setLineBreakText(element, text)
    })
  }

  setLineBreakText(element, text) {
    element.innerHTML = text.join(' ')
  }

  getRandomIndex() {
    const min = 1
    const max = FactsData.data.length
    const index = min + Math.floor((max - min) * Math.random())

    if (FactsData.data[index].default === false) {
      this.getRandomIndex()
    }
    return index
  }

  getFactData() {
    const index = this.getRandomIndex()

    this.data = FactsData.data[index]
    this.data.tagName = this.props.factsTags.filter((obj) => {
      return obj.id === this.data.tag
    })[0].name

    return this.data
  }

  nextFact() {
    this.modal.classList.add('next')
    this.prevData = this.data
    this.data = this.getFactData()

    this.setState({
      addNewModalContent: true,
      canClickNextFact: false
    })

    this.getLineBreakText(this.modal.querySelector('.description'))

    setTimeout(() => {
      this.modal.classList.remove('next')

      this.setState({
        addNewModalContent: false
      })
    }, 500)

    setTimeout(() => {
      this.setState({
        canClickNextFact: true
      })
    }, 1500)
  }

  goToFact() {
    window.location.hash = this.data.id
    window.location.reload()
  }

  render() {
    return (
      <>
        <div className="modal-content">
          <ScrollBar>
            <div className="modal-content-wrapper">
              <div className="introduction">
                <div>
                  <div className="logo-160"/>
                  <div className="introductory-text">
                    Мы&nbsp;собрали 160 фактов о&nbsp;деньгах и&nbsp;работе Центрального
                    банка с&nbsp;1860 года до&nbsp;наших дней. Смотрите:
                  </div>
                </div>
                <div className="logo"/>
              </div>

              <div className="fact-wrapper">
                <div className="fact">
                  <Tag
                    {...this.props}
                    tagId={this.data.tag}
                    title={this.data.tagName}
                  />

                  <div
                    className="description"
                    data-lines="6"
                    dangerouslySetInnerHTML={{ __html: this.data.description }}
                    onClick={() => this.goToFact()}
                  />

                  <SocialSharing id={this.data.id} mainText={this.data.description} topIndent />
                </div>

                <div className="fact-images">
                  <div className="main-image">
                    <Image
                      alt=""
                      src={require('../../assets/images/facts/' + (this.state.addNewModalContent ? this.prevData.id : this.data.id) + '/main.png')}
                      withGradient={this.state.addNewModalContent ? this.prevData.imageWithGradient : this.data.imageWithGradient}
                    />
                  </div>
                </div>
              </div>

              <div>
                <Button className={classNames('secondary', {'disabled' : !this.state.canClickNextFact})} title={'Другой факт'} withIcon={'reload'}/>
              </div>

              <Copyright
                {...this.props}
              />
            </div>
          </ScrollBar>
        </div>
        <div className="all-facts">Все факты вместе</div>
      </>
    )
  }
}

export default ModalDefault
